import React from 'react';
import cx from 'clsx';
import styles from './divider.module.css';

export function Divider(props: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div {...props} className={cx(styles.divider, props.className || '')} />;
}
